export const SEARCH_MOVIE='SEARCH_MOVIE'; //ACCION DE BUSQUEDA AL ESCRIBIR EN EL INPUT
export const FETCH_MOVIE='FETCH_MOVIE';//ACCION DE BUSCAR TEXTO DEL INPUT CON TITULOS DE PELICULAS EL LOS DATOS DE LA API
export const FETCH_MOVI='FETCH_MOVI'//BUSCAR INFORMACION DE PELICULA SELECIONADA
export const LOADING='LOADING'